// Human-readable file size (SI units), shared across the ImportPhoto tabs.
export function humanFileSize(bytes: number) {
  if (bytes < 1000) return `${bytes} B`;
  const units = ["kB", "MB", "GB"];
  let value = bytes;
  let u = -1;
  do {
    value /= 1000;
    u++;
  } while (value >= 1000 && u < units.length - 1);
  return `${value.toFixed(1)} ${units[u]}`;
}
